import {STRATEGY_JS_STRATEGY_MANAGE, STRATEGY_JS_STRATEGY_HISTORY} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/strategy/jsStrategy/index.vue'),
    path: 'jsStrategy',
    name: STRATEGY_JS_STRATEGY_MANAGE,
    meta: {
        title: 'JS策略',
        name: STRATEGY_JS_STRATEGY_MANAGE
    }
};

export const JsStrategyHistory = {
    component: () => import('@/views/strategy/jsStrategy/history/index.vue'),
    path: 'jsStrategyHistory',
    name: STRATEGY_JS_STRATEGY_HISTORY,
    meta: {
        title: 'JS策略操作日志',
        name: STRATEGY_JS_STRATEGY_HISTORY
    }
};